import { useLazyQuery, useQuery } from "@apollo/client";
import { THEME } from "../theme.queries";
import { ThemeQuery, ThemeQueryVariables } from "../../../__generated__/ThemeQuery";

export const useTheme = (id: number) => {
  return useQuery<ThemeQuery, ThemeQueryVariables>(THEME, { variables: { id } });
};

export const useLazyTheme = () => {
  return useLazyQuery<ThemeQuery, ThemeQueryVariables>(THEME);
};
